import React, { useEffect, useState } from "react";
import StatusComp from "../../../components/StatusComp";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { group1, group3, group2 } from "../../redux/api/dummyJson";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { user, green_icon, red_icon } from "../../../assets/imgs";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import AdminNotificationsComp from "../../Notifications/AdminNotificationsComp";
import AdminSlotMainComp from "../Slot/AdminSlotMainComp";
import AdminAlertTypesComp from "../Alert/AdminAlertTypesComp";
import AdminCamerasComp from "../Camera/AdminCamerasComp";
import CommonDatePickerReports from "../../../components/CommonDatePickerReports";
import AllReports from "../../Notifications/AllReports";

const SitesView = () => {
  const location = useLocation();
  const { type, data } = location.state;
  //   console.log("data", data);
  const [list, setList] = useState({});
  const [groupCat, setGroupCat] = useState({});
  const [btnTab, setBtnTab] = useState(6);

  const navigate = useNavigate();
  const [createdAt, setCreatedAt] = useState("");

  const getSiteUser = () => {
    let formdata = new FormData();
    formdata.append("company_id", data?.company_id);
    formdata.append("site_id", data?.id);
    post(URL.COMPANY_SITE_USER_LIST, formdata)
      .then((res) => {
        if (res?.data?.length > 0) {
          let data_ = res?.data?.[0];
          setList(data_);
          if (data_?.admin_created_at) {
            setCreatedAt(moment(data_?.admin_created_at).format("DD-MM-YYYY"));
          }
          let groupUsers = data_?.users;
          let groupCat_ = {};
          if (groupUsers?.length > 0) {
            for (let i of groupUsers) {
              let key = i.knf_type;
              if (!groupCat_[key]) {
                groupCat_[key] = [];
              }
              groupCat_[key].push(i);
              setGroupCat(groupCat_);
            }
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getSiteUser();
  }, []);

  // TAB 1

  // console.log("list", list);

  return (
    <div className="dashRightView">
      <StatusComp name={"Site"} type={type} />
      <div className="d-flex p-1">
        <div className="col-md-4 p-3">
          <div className="p-2 mb-2">
            <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Company Name & Code
            </p>
            <input
              className="input-box w-100"
              readOnly
              value={`${list?.company_name ?? "-"} - ${
                list?.company_code ?? "-"
              }`}
            />
          </div>

          <div className="p-2 mb-2">
            <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Name & Code
            </p>
            <input
              className="input-box w-100"
              readOnly
              value={`${list?.site_name ?? "-"} - ${list?.site_code ?? "-"}`}
            />
          </div>
        </div>
        <div className="col-md-4 p-3">
          <div className="p-2 mb-2">
            <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Location
            </p>
            <input
              className="input-box w-100"
              readOnly
              value={list?.location_name ?? "-"}
            />
          </div>
          <div className="p-2 mb-2">
            <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Admin
            </p>
            <input
              className="input-box w-100"
              readOnly
              value={list?.company_owner_name ?? "-"}
            />
          </div>
        </div>
        <div className="col-md-4 p-3">
          <div className="p-2 mb-2">
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
              Admin Created On
            </p>
            <input className="input-box w-100" readOnly value={createdAt} />
          </div>
        </div>
      </div>

      <div className="col-md-10 p-3 d-flex ac-jb">
        <div className="p-2 mb-2">
          <button
            className={`${btnTab == 6 ? "submit-btn" : "back-btn"}`}
            onClick={() => {
              setBtnTab(6);
              // navigate("/site-report", {
              //   state: { type: "site-view", data: list },
              // });
            }}
          >
            Group Users
          </button>
        </div>
        <div className="p-2 mb-2">
          <button
            className={`${btnTab == 1 ? "submit-btn" : "back-btn"}`}
            onClick={() => {
              setBtnTab(1);
            }}
          >
            View Report
          </button>
        </div>

        <div className="p-2 mb-2">
          <button
            className={`${btnTab == 2 ? "submit-btn" : "back-btn"}`}
            onClick={() => {
              setBtnTab(2);
            }}
          >
            View Notifications
          </button>
        </div>

        <div className="p-2 mb-2">
          <button
            className={`${btnTab == 3 ? "submit-btn" : "back-btn"}`}
            onClick={() => {
              setBtnTab(3);
            }}
          >
            Slot Days
          </button>
        </div>

        <div className="p-2 mb-2">
          <button
            className={`${btnTab == 4 ? "submit-btn" : "back-btn"}`}
            onClick={() => {
              setBtnTab(4);
            }}
          >
            Alert Types
          </button>
        </div>

        <div className="p-2 mb-2">
          <button
            className={`${btnTab == 5 ? "submit-btn" : "back-btn"}`}
            onClick={() => {
              setBtnTab(5);
            }}
          >
            Cameras
          </button>
        </div>
      </div>

      {btnTab == 6 && (
        <div className="row d-flex flex-wrap align-items-start justify-content-between">
          <div className="col-md-4">
            {groupCat?.[3]?.length > 0 && (
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
                Group-1 ({groupCat?.[3]?.length})
              </p>
            )}
            <div className="w-100 ">
              {groupCat?.[3]?.map((item, ind) => {
                return (
                  <div
                    key={ind}
                    className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
                  >
                    <div className="d-flex ac-jb">
                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Name
                        </p>
                        <input
                          className="input-box w-100"
                          readOnly
                          value={item?.name}
                        />
                      </div>
                      <img
                        src={
                          item?.profile_image?.name
                            ? URL.createObjectURL(item.profile_image)
                            : item?.profile_image
                            ? item.profile_image
                            : user
                        }
                        alt=""
                        className="user mb-1"
                        style={{
                          height: "70px",
                          width: "70px",
                        }}
                      />
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Email
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.email}
                      />
                      <div className="d-flex ac-js mt-2 gap-2">
                        <img
                          src={item?.is_email_verified ? green_icon : red_icon}
                          className="redImg"
                        />
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          {item?.is_email_verified
                            ? "Verified"
                            : "Not Verified"}
                        </p>
                      </div>
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Mobile
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.phone}
                      />
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Created On
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={
                          item?.created_at
                            ? moment(item?.created_at).format("DD-MM-YYYY")
                            : ""
                        }
                      />
                    </div>

                    <div className="d-flex ac-jb gap-3">
                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Alert Notifications
                        </p>
                        {item?.notification_alert ? (
                          <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                        ) : (
                          <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                        )}
                      </div>

                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Beep Sound
                        </p>
                        {item?.beep_sound ? (
                          <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                        ) : (
                          <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="col-md-4">
            {groupCat?.[4]?.length > 0 && (
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
                Group-2 ({groupCat?.[4]?.length})
              </p>
            )}
            <div className="w-100 ">
              {groupCat?.[4]?.map((item, ind) => {
                return (
                  <div
                    key={ind}
                    className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
                  >
                    <div className="d-flex ac-jb">
                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Name
                        </p>
                        <input
                          className="input-box w-100"
                          readOnly
                          value={item?.name}
                        />
                      </div>
                      <img
                        src={
                          item?.profile_image?.name
                            ? URL.createObjectURL(item.profile_image)
                            : item?.profile_image
                            ? item.profile_image
                            : user
                        }
                        alt=""
                        className="user mb-1"
                        style={{
                          height: "70px",
                          width: "70px",
                        }}
                      />
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Email
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.email}
                      />
                      <div className="d-flex ac-js mt-2 gap-2">
                        <img
                          src={item?.is_email_verified ? green_icon : red_icon}
                          className="redImg"
                        />
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          {item?.is_email_verified
                            ? "Verified"
                            : "Not Verified"}
                        </p>
                      </div>
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Mobile
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.phone}
                      />
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Created On
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={
                          item?.created_at
                            ? moment(item?.created_at).format("DD-MM-YYYY")
                            : ""
                        }
                      />
                    </div>

                    <div className="d-flex ac-jb gap-3">
                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Alert Notifications
                        </p>
                        {item?.notification_alert ? (
                          <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                        ) : (
                          <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                        )}
                      </div>

                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Beep Sound
                        </p>
                        {item?.beep_sound ? (
                          <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                        ) : (
                          <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="col-md-4">
            {groupCat?.[5]?.length > 0 && (
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
                Group-3 ({groupCat?.[5]?.length})
              </p>
            )}
            <div className="w-100 ">
              {groupCat?.[5]?.map((item, ind) => {
                return (
                  <div
                    key={ind}
                    className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary"
                  >
                    <div className="d-flex ac-jb">
                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Name
                        </p>
                        <input
                          className="input-box w-100"
                          readOnly
                          value={item?.name}
                        />
                      </div>
                      <img
                        src={
                          item?.profile_image?.name
                            ? URL.createObjectURL(item.profile_image)
                            : item?.profile_image
                            ? item.profile_image
                            : user
                        }
                        alt=""
                        className="user mb-1"
                        style={{
                          height: "70px",
                          width: "70px",
                        }}
                      />
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Email
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.email}
                      />
                      <div className="d-flex ac-js mt-2 gap-2">
                        <img
                          src={item?.is_email_verified ? green_icon : red_icon}
                          className="redImg"
                        />
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          {item?.is_email_verified
                            ? "Verified"
                            : "Not Verified"}
                        </p>
                      </div>
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Mobile
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={item?.phone}
                      />
                    </div>

                    <div>
                      <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                        Created On
                      </p>
                      <input
                        className="input-box w-100"
                        readOnly
                        value={
                          item?.created_at
                            ? moment(item?.created_at).format("DD-MM-YYYY")
                            : ""
                        }
                      />
                    </div>

                    <div className="d-flex ac-jb gap-3">
                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Alert Notifications
                        </p>
                        {item?.notification_alert ? (
                          <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                        ) : (
                          <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                        )}
                      </div>

                      <div>
                        <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                          Beep Sound
                        </p>
                        {item?.beep_sound ? (
                          <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                        ) : (
                          <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {btnTab == 1 && <AllReports />}
      {btnTab == 2 && <AdminNotificationsComp />}
      {btnTab == 3 && <AdminSlotMainComp />}
      {btnTab == 4 && <AdminAlertTypesComp />}
      {btnTab == 5 && <AdminCamerasComp />}

      <div className="d-flex ac-jb ">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default SitesView;
